import {Component, Input, OnInit} from '@angular/core';
import {ID_SIDEBAR, NavUtils} from '../../utils';
import {NavItem, NavItemsId, NavItemsType} from '@pt/pt-models';
import {StorageInfo} from '@primatoo-ms-organization';
import {of} from "rxjs";

const COLLAPSED_SIBAR_KEY = 'sidebarCollapsed'

@Component({
  selector: 'pt-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() items: NavItem[];
  @Input() administration: boolean;
  @Input() storageInfo: StorageInfo;
  @Input() version?: string;

  ID = ID_SIDEBAR;
  toogle: NavItem = NavUtils.create({id: NavItemsId.TOGGLE, type: NavItemsType.TOGGLE, label: of(null)});
  storage: NavItem = NavUtils.create({id: NavItemsId.STORAGE, type: NavItemsType.STORAGE, label: of(null)});

  opened = true;
  itemMenuOpenedId: string;

  ngOnInit() {
    const collapsed = localStorage.getItem(COLLAPSED_SIBAR_KEY);
    if (collapsed) {
      this.opened = JSON.parse(collapsed);
    }
  }

  toggleOpened(): void {
    this.opened = !this.opened;
    localStorage.setItem(COLLAPSED_SIBAR_KEY, this.opened.toString());
  }

  trackById(index, item: NavItem) {
    return item.id;
  }

  onOpenMenuItem($event: NavItem) {
    if ($event.type === NavItemsType.MENU) {
      this.itemMenuOpenedId = $event.id;
    }
  }
}

